<template>
    <b-container fluid id="layout_section_component"
                 v-if="auth">
        <b-row>
            <main-menu :title="'Calculator'"></main-menu>
            <calculator-content v-if="!mobileMenu"></calculator-content>
        </b-row>
    </b-container>
</template>

<script>
    import MainMenu from '../menu/MainMenu.vue'
    import CalculatorContent from '../content/CalculatorContent.vue'

    export default {
        props: ['auth', 'mobile, user'],
        components: { MainMenu, CalculatorContent },
        computed: {
            mobileMenu () {
                return this.$store.getters.mobileMenu
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/pages/Calculator.vue